<template lang="pug">
button(
    :class="classes"
    :disabled="value === id"
    @click="$emit('input', id)"
)
    span
    p
        slot
</template>

<script lang="ts">
import Vue, { computed, useCssModule } from 'vue'

export type RadioProps = {
    value: string
    id: string | number
}

export default Vue.extend({
    name: 'Radio',
    props: {
        value: String,
        id: String,
    },
    setup(props) {
        const styles = useCssModule()
        const classes = computed(() => {
            return [styles.root, props.value === props.id && styles.checked]
        })

        return {
            styles,
            classes,
        }
    },
})
</script>

<style module lang="scss" src="./Radio.module.scss" />
